import moment from 'moment';

/*
 * Styles : mc-account-requests.css (importé par la page qui liste les notifications).
 */

function NotificationItem({ data }) {
  return (
    <article className="mc-req-item mc-req-item--static">
      <span className="mc-req-icon" aria-hidden="true">
        <i className="bi bi-bell"></i>
      </span>

      <div className="mc-req-body">
        <h3 className="mc-req-title">{data.Titre}</h3>
        {data.message && <p className="mc-req-text">{data.message}</p>}
        <p className="mc-req-meta">
          <span>
            <i className="bi bi-clock" aria-hidden="true"></i>
            {moment(data.createdAt).calendar()}
          </span>
        </p>
      </div>

      <div className="mc-req-side">
        <span className="mc-req-dot" title="Nouvelle notification">
          <span className="visually-hidden">Nouvelle notification</span>
        </span>
      </div>
    </article>
  );
}

export default NotificationItem;
